module.exports = __webpack_public_path__ + "static/media/icon_arrow_right_black.dd99aa68.svg";